/**
 * @generated SignedSource<<c24861360e167ad23ac8454f2f909e0a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LockGrantType = "ANONYMOUS" | "ORGANIZATION" | "USER" | "%future added value";
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type ShareAccessAccountDrawerReservationQuery$variables = {
  reservationId: string;
};
export type ShareAccessAccountDrawerReservationQuery$data = {
  readonly reservation: {
    readonly id?: string;
    readonly utilizationGrants?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly permissions: ReadonlyArray<UtilizationGrantPermission>;
        readonly toEmail: string | null | undefined;
        readonly toOrganization: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly toUser: {
          readonly email: string;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly ty: LockGrantType;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type ShareAccessAccountDrawerReservationQuery = {
  response: ShareAccessAccountDrawerReservationQuery$data;
  variables: ShareAccessAccountDrawerReservationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reservationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "reservationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "active": true
      }
    },
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 1000
      }
    }
  ],
  "concreteType": "UtilizationGrantPage",
  "kind": "LinkedField",
  "name": "utilizationGrants",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UtilizationGrant",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ty",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "permissions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "toUser",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "toOrganization",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toEmail",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "utilizationGrants(filter:{\"active\":true},pagination:{\"page\":0,\"pageSize\":1000})"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareAccessAccountDrawerReservationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              {
                "kind": "CatchField",
                "field": (v4/*:: as any*/),
                "to": "NULL"
              }
            ],
            "type": "LockReservation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ShareAccessAccountDrawerReservationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "type": "LockReservation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9eac12edd649dc8df437fab59ddc2e7d",
    "id": null,
    "metadata": {},
    "name": "ShareAccessAccountDrawerReservationQuery",
    "operationKind": "query",
    "text": "query ShareAccessAccountDrawerReservationQuery(\n  $reservationId: UUID!\n) {\n  reservation(id: $reservationId) {\n    __typename\n    ... on LockReservation {\n      id\n      utilizationGrants(filter: {active: true}, pagination: {page: 0, pageSize: 1000}) {\n        nodes {\n          id\n          ty\n          permissions\n          toUser {\n            id\n            name\n            email\n          }\n          toOrganization {\n            id\n            name\n          }\n          toEmail\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4be853b18f5c0a917cf172deb1baf713";

export default node;
